import { Navigate } from 'react-router-dom';
import { Spinner } from '@shared/ui';
import { useProfileQuery, isKycActionable } from '@entities/manufacturer';
import { ROUTES } from '@shared/config/routes';
import { AnalyticsDashboard } from '@features/analytics-dashboard';

export function DashboardPage() {
  const { data: profile, isLoading } = useProfileQuery();

  if (isLoading) {
    return (
      <div className="flex h-full items-center justify-center">
        <Spinner />
      </div>
    );
  }

  if (profile && isKycActionable(profile.kycStatus)) {
    return <Navigate to={`${ROUTES.profile}?kyc=onboarding`} replace />;
  }

  return <AnalyticsDashboard />;
}
